import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    Checkbox
} from '@mui/material';
import { getDisplayPrice } from '../Common/Price';

function ConfigureExtrasDialog({
    open = false,
    onClose = () => { },
    onConfirm = () => { },
    items = [],
    categoryName = ''
}) {
    const [configuredItems, setConfiguredItems] = useState([]);

    // Initialiser les items avec leurs prix supplémentaires
    useEffect(() => {
        if (open && items.length > 0) {
            setConfiguredItems(items.map(item => ({
                ...item,
                extraPrice: 0,
                selected: true
            })));
        }
    }, [open, items]);

    const handleExtraPriceChange = (itemId, value) => {
        setConfiguredItems(prev =>
            prev.map(item =>
                item.id === itemId
                    ? { ...item, extraPrice: parseFloat(value) || 0 }
                    : item
            )
        );
    };

    const handleToggleSelect = (itemId) => {
        setConfiguredItems(prev =>
            prev.map(item =>
                item.id === itemId
                    ? { ...item, selected: !item.selected }
                    : item
            )
        );
    };

    const handleSelectAll = (checked) => {
        setConfiguredItems(prev =>
            prev.map(item => ({ ...item, selected: checked }))
        );
    };

    const handleConfirm = () => {
        const selectedItems = configuredItems
            .filter(item => item.selected)
            .map(item => ({
                id: item.id,  
                extraPrice: item.extraPrice
            }));
            onConfirm(selectedItems);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                Configuration des prix supplémentaires - {categoryName}
            </DialogTitle>
            <DialogContent>
                <TableContainer component={Paper} elevation={3} sx={{ mt: 2 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        checked={configuredItems.every(item => item.selected)}
                                        indeterminate={configuredItems.some(item => item.selected) && !configuredItems.every(item => item.selected)}
                                        onChange={(e) => handleSelectAll(e.target.checked)}
                                    />
                                </TableCell>
                                <TableCell>Nom</TableCell>
                                <TableCell>Prix de base</TableCell>
                                <TableCell>Supplément</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {configuredItems.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    sx={{
                                        bgcolor: item.selected ? 'inherit' : 'action.hover',
                                        '&:hover': { bgcolor: 'action.hover' }
                                    }}
                                >
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            checked={item.selected}
                                            onChange={() => handleToggleSelect(item.id)}
                                        />
                                    </TableCell>
                                    <TableCell>{item.name}</TableCell>
                                    <TableCell>{getDisplayPrice(item)} €</TableCell>
                                    <TableCell>
                                        <TextField
                                        type="number"
                                        value={item.extraPrice}
                                        onChange={(e) => handleExtraPriceChange(item.id, e.target.value)}
                                        size="small"
                                        InputProps={{
                                            startAdornment: '+',
                                            endAdornment: '€',
                                            inputProps: {
                                            min: 0,
                                            step: 0.5,
                                            style: { width: '80px' },
                                            onWheel: (e) => {
                                                // Empêcher le défilement par défaut
                                                e.preventDefault();
                                                // Retirer le focus pour éviter le changement de valeur
                                                e.target.blur();
                                            }
                                            }
                                        }}
                                        disabled={!item.selected}
                                        />                                    
                                        </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Résumé */}
                <Box sx={{ mt: 2, p: 2, bgcolor: 'primary.light', color: 'primary.contrastText', borderRadius: 1 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                        Résumé
                    </Typography>
                    <Typography>
                        Items sélectionnés : {configuredItems.filter(item => item.selected).length}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Annuler
                </Button>
                <Button
                    variant="contained"
                    onClick={handleConfirm}
                    disabled={!configuredItems.some(item => item.selected)}
                >
                    Confirmer
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfigureExtrasDialog;